#import "../fragments/account-hierarchy-info-fragment.graphql"

mutation RemoveAccountParentRelationship($input: AccountParentRemoveInput!) {
    accountParentRemove(input: $input) {
        account {
            ...AccountHierarchyInfoFragment
        }
        parentAccount {
            ...AccountHierarchyInfoFragment
        }
    }
}
